import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { CardCell } from 'modules/journey/card/styled';

import StopRowStyled from '../styled';

import {
  AddressCompanyNameCell,
  AddressLabelCell,
  StopIconCell,
  StopNumberOfItemsCell,
  StopWeightCell,
  StopCommentsCell,
  StopHandlingCell,
  StopTimesCell,
  StopStatusCell,
} from 'modules/journey/card/cells';
import { IS_TENANT } from 'tenant/config';

const AssignedStopRow = ({
  skin,
  isPartiallyCancelled,
  showLoadInfo,
  className,
  journeyId,
  stopId,
  store,
  isAggregated,
}) => {
  return (
    <StopRowStyled
      className={className}
      skin={skin}
      lightCell={isPartiallyCancelled}
      store={store}
      isAggregated={isAggregated}
    >
      <CardCell mRight="S,XS" cellWidth={'250,186,180'} cellOverflow cellColor="grey700">
        <AddressCompanyNameCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell mRight="M,XS" cellWidth={'194,130,120'} cellOverflow cellColor="grey700">
        <AddressLabelCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell cellWidth={'16,16,0'}>
        {showLoadInfo && <StopIconCell journeyId={journeyId} stopId={stopId} />}
      </CardCell>
      <CardCell
        cellWidth={'40,40,0'}
        mRight="S,XS"
        alignRight
        cellColor="grey700"
        fontWeight="normal"
      >
        {showLoadInfo && !IS_TENANT && (
          <StopNumberOfItemsCell journeyId={journeyId} stopId={stopId} />
        )}
      </CardCell>
      <CardCell
        cellWidth={'62,62,0'}
        mRight="S,XS"
        alignRight
        cellColor="grey700"
        fontWeight="normal"
      >
        {showLoadInfo && !IS_TENANT && <StopWeightCell journeyId={journeyId} stopId={stopId} />}
      </CardCell>
      <CardCell cellWidth={16} mRight="XS">
        <StopCommentsCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell cellWidth={16} mRight="S">
        <StopHandlingCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      {/* tweak because the design has 20px margin... */}
      <CardCell cellWidth={'4,4,0'} />
      <CardCell cellWidth={88} mRight="XS" alignRight boldText cellColor="grey700">
        <StopTimesCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
      <CardCell cellWidth={444} cellHeight={'100%'}>
        <StopStatusCell journeyId={journeyId} stopId={stopId} />
      </CardCell>
    </StopRowStyled>
  );
};

AssignedStopRow.propTypes = {
  skin: PropTypes.string.isRequired,
  showLoadInfo: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  journeyId: PropTypes.number.isRequired,
  stopId: PropTypes.number.isRequired,
  isPartiallyCancelled: PropTypes.bool,
};

export default memo(AssignedStopRow);
